import axios from "axios";
import resolveBaseUrl from "../services";
import { currentTenant } from "../utils/Helpers";

//pass new generated access token here
const token = localStorage.getItem("__eyfort__access__token__");

const getTenantId = () => {
  const tenant = currentTenant();
  return tenant ? tenant.id : null;
}

const tenantId = getTenantId();

//apply base url for axios
const API_URL = resolveBaseUrl();

const axiosApi = axios.create({
  baseURL: API_URL
});

if (token) {
  axiosApi.defaults.headers.common["Authorization"] = token;
}

if(tenantId) {
  axiosApi.defaults.headers.common["TENANT"] = tenantId;
}

// content type
axiosApi.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axiosApi.interceptors.response.use(function(response) {
  return response;
}, function(error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  let message;
  switch (error.status) {
    case 500:
      message = "Internal Server Error";
      break;
    case 401:
      message = "Invalid credentials";
      break;
    case 404:
      message = "Sorry! the data you are looking for could not be found";
      break;
    default:
      message = error.message || error;
  }
  return Promise.reject(message);
});


class ApiCore {
  /**
   * Fetches data from given url
   */
  get = (url: string, params?: {}, responseType: any = "json") => {
    url = API_URL + url;
    axiosApi.defaults.responseType = responseType;
    return axiosApi.get(url, params);
  };

  getWithHeaders = (url: string, t: any, code: any) => {
    url = API_URL + url;
    axiosApi.defaults.headers.common["Authorization"] = t;
    if(tenantId) {
      axiosApi.defaults.headers.common["TENANT"] = code;
    }
    return axiosApi.get(url, {});
  };

  /**
   * post given data to url
   */
  create = (url: string, data: {}) => {
    url = API_URL + url;
    return axiosApi.post(url, data);
  };

  createFormData = (url: string, data: any, responseType: any = "json") => {
    let params = new FormData();
    for ( var key in data ) {
      params.append(key, data[key]);
    }
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": token,
        "TENANT": tenantId,
      },
    };
    url = API_URL + url;
    axiosApi.defaults.responseType = responseType;
    return axiosApi.post(url, params, headers);
  };

  updateFormData = (url: string, data: any, responseType: any = "json") => {
    let params = new FormData();
    for ( var key in data ) {
      params.append(key, data[key]);
    }
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": token,
        "TENANT": tenantId,
      },
    };
    url = API_URL + url;
    axiosApi.defaults.responseType = responseType;
    return axiosApi.put(url, params, headers);
  };

  /**
   * Updates data
   */
  update = (url: string, data: {}) => {
    url = API_URL + url;
    return axiosApi.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url: string, data?: {}) => {
    url = API_URL + url;
    return axiosApi.delete(url, { ...data });
  };

  test = () => {

  };
};

export { ApiCore };